import React, { Component } from 'react';
import Constants from '../../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../../../common/inputs/select';
import TextBox from '../../../common/inputs/textBox';

const initialObjectState = {
  param_type: "",
  type: Constants.selectKeys.formulaEditor.formulaParamTypes.FREE,
  value: "",
  is_logic_function: "",
  right_logical_override_string: ""
}

class FunctionParamsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }
  
  componentDidMount() {
    this.props.escBehaviourHandler(false);
  }

  componentWillUnmount = () => {
    this.props.escBehaviourHandler(false); 
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {
    if(object.value == "" && !object.allow_empty &&
      (object.param_type==Constants.formulaEditor.functionParamsTypes.logicalFormula ||
        object.param_type==Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula ||
        object.param_type==Constants.formulaEditor.functionParamsTypes.metricsList ||
        object.param_type==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList ||
        object.param_type==Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList ||
        object.param_type==Constants.formulaEditor.functionParamsTypes.string ||
        (object.param_type==Constants.formulaEditor.functionParamsTypes.optionsToSetDimension && object.type==Constants.selectKeys.formulaEditor.optionsToSetDimensionTypes.HISTORIC_PERIODS))
    ) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.polynomialDimensionsError"}),"");
      return false;
    }
    return true;
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      let newValue = JSON.parse(event.currentTarget.dataset.value);
      newValue.param_type = event.currentTarget.dataset.addtype;
      event.currentTarget.dataset.value = JSON.stringify(newValue);
      this.props.onChange(event);
      this.setState({
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({  
      showOverlay: true,    
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
    this.props.escBehaviourHandler(true);
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    let editableOverrideFormulaString = toEditObject.optional_formula_override_string && toEditObject.param_type==Constants.formulaEditor.functionParamsTypes.formula;
    toEditObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path == "type") {
      toEditObject.value = "";
    }
    if(editableOverrideFormulaString && !value) {
      toEditObject.type = Constants.selectKeys.formulaEditor.formulaParamTypes.FREE;
    }
    else if(editableOverrideFormulaString && value) {
      toEditObject.type = Constants.selectKeys.formulaEditor.formulaParamTypes.STRING;
    }
    if(toEditObject.param_type==Constants.formulaEditor.functionParamsTypes.logicalFormula && value == Constants.selectKeys.formulaEditor.logicalComparators.oneterm) {
      toEditObject.right_logical_override_string = "";
    }
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
    this.props.escBehaviourHandler(false);
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
      this.props.escBehaviourHandler(false);
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  render() {
    const {
      className,
      enableAdd,
      addType,
      addLabel,
      addButtonLabel,
      addLimit,
      paramsNumber,
      values,
      compareOptions,
      isLogicFunctionOptions,
      onChange,
      handleGoToEditFormula,
      disabled,
      escBehaviourHandler,
    } = this.props;
    const dataPath = this.props["data-path"];
    let fullOptionalParams = enableAdd && addLimit && (values.length >= paramsNumber + addLimit);
    return (
      <div className={"custom-input free-text-list select-list object-editor formula-dimensions-param-editor" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.functionLabel"/>
          {(enableAdd && !fullOptionalParams && !disabled) && (
            <React.Fragment>
              <i 
                className="fas fa-plus-circle"
                data-functionparameditor={"true"}
                data-value={JSON.stringify(this.state.toAddObject)}  
                data-path={dataPath}
                data-addtype={addType}
                onClick={this.handleSaveAddItem} 
              />
              {addButtonLabel && (
                <div className="formula-dimensions-param-editor-add-button-label">{"(" + addButtonLabel.toLowerCase() + ")"}</div>
              )}
            </React.Fragment>
          )}
        </div>
          <div className={"free-text-list-list-wrapper"}>
            {values && values.map((item,i) => {
              if(!item) {
                return null;
              }
              let editable = (item.param_type==Constants.formulaEditor.functionParamsTypes.metricsList ||
                item.param_type==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList ||
                item.param_type==Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList ||
                item.param_type==Constants.formulaEditor.functionParamsTypes.string ||
                item.param_type==Constants.formulaEditor.functionParamsTypes.optionsToSetDimension);
              let editableOverrideFormulaString = item.optional_formula_override_string && item.param_type==Constants.formulaEditor.functionParamsTypes.formula;
              let defaultParameterLabel = addLabel ? addLabel : (intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.defaultParameterLabel"}) + " N°" + i);
              let label = item.label ? item.label : defaultParameterLabel;
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className={"free-text-list-list-item-inner object-editor-inputs" + ((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula || item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) ? " object-editor-inputs-logical" : "")}>
                      <div className="object-editor-inputs-linebreak"> 
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          value={label}
                          disabled={true}
                          type={Constants.interface.inputs.type.TEXT}
                        />
                        {(item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula) && (
                          <Select 
                            className="free-text-list-list-add-item formula-dimensions-param-editor-is-logic-function"
                            value={this.state.toEditObject.is_logic_function}
                            options={isLogicFunctionOptions}
                            onChange={this.handleChangeEdit}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.isFunctionLabel"/>}
                            data-path={"is_logic_function"}
                          />
                        )}
                        {(item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) && (
                          <Select 
                            className="free-text-list-list-add-item formula-dimensions-param-editor-is-logic-function"
                            value={this.state.toEditObject.is_logic_function}
                            options={isLogicFunctionOptions}
                            onChange={this.handleChangeEdit}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.isDimensionRangeLabel"/>}
                            data-path={"is_logic_function"}
                          />
                        )}
                        {((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula || item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) && !this.state.toEditObject.is_logic_function) && (
                          <React.Fragment>
                            <Select 
                              className="free-text-list-list-add-item formula-dimensions-param-editor-value formula-dimensions-param-editor-value-compare-logical"
                              value={this.state.toEditObject.value}
                              options={compareOptions}
                              onChange={this.handleChangeEdit}
                              data-path={"value"}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item formula-dimensions-param-editor-right_logical_override_string"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"right_logical_override_string"}
                              value={this.state.toEditObject.right_logical_override_string}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              disabled={this.state.toEditObject.value==Constants.selectKeys.formulaEditor.logicalComparators.oneterm}
                              labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueOverrideLogicalFormulaRightLabel"/>}
                            />
                          </React.Fragment>
                        )}
                        {((editable || editableOverrideFormulaString) && !item.options_list && item.param_type != Constants.formulaEditor.functionParamsTypes.optionsToSetDimension) ? (
                          <TextBox
                            className="free-text-list-list-edit-item formula-dimensions-param-editor-value"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeEdit}
                            data-path={"value"}
                            value={this.state.toEditObject.value}
                            onKeyEnter={this.handleOnEnterEditItem}
                            dataType={item.param_format}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={!editableOverrideFormulaString ? (<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueOverrideFormulaLabel"/>)}
                          />
                        ) : ((editable || editableOverrideFormulaString) && item.options_list && item.param_type != Constants.formulaEditor.functionParamsTypes.optionsToSetDimension) ? (
                          <Select 
                            className="free-text-list-list-add-item formula-dimensions-param-editor-value"
                            value={this.state.toEditObject.value}
                            options={item.options_list}
                            onChange={this.handleChangeEdit}
                            labelLocale={!editableOverrideFormulaString ? (<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueOverrideFormulaLabel"/>)}
                            data-path={"value"}
                          />
                        ) : null}
                        {(item.param_type == Constants.formulaEditor.functionParamsTypes.optionsToSetDimension) && (
                          <Select 
                            className="free-text-list-list-add-item formula-dimensions-param-editor-type"
                            value={this.state.toEditObject.type}
                            options={item.options_to_set_dimension_list}
                            onChange={this.handleChangeEdit}
                            labelLocale={(<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.typeLabel"/>)}
                            data-path={"type"}
                          />
                        )}
                        {(item.param_type == Constants.formulaEditor.functionParamsTypes.optionsToSetDimension && this.state.toEditObject.type == Constants.selectKeys.formulaEditor.optionsToSetDimensionTypes.HISTORIC_PERIODS) && (
                          <TextBox
                            className="free-text-list-list-edit-item formula-dimensions-param-editor-value"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeEdit}
                            data-path={"value"} 
                            value={this.state.toEditObject.value}
                            onKeyEnter={this.handleOnEnterEditItem}
                            type={Constants.interface.inputs.type.TEXT}
                            dataType={Constants.selectKeys.metric.dataType.NUMBER}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.optionsToSetDimensionLastPeriodNumberLabel"/>}
                          />
                        )}
                      </div>
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-functionparameditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let itemInnerText = label + ": ";                
                if((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula) && item.is_logic_function) {
                  itemInnerText += intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.isLogicSpecialFunctionValues.true"}) + " ";
                }
                else if((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) && item.is_logic_function) {
                  itemInnerText += intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.isLogicDimensionSpecialFunctionValues.true"}) + ", ";
                }
                if(editable && item.param_type==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList && 
                  item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.METRIC_VALUE && item.value) {
                  itemInnerText += intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues.metric_value"});
                }
                else if(item.param_type==Constants.formulaEditor.functionParamsTypes.optionsToSetDimension && item.type!=Constants.selectKeys.formulaEditor.formulaParamTypes.FREE) {
                  itemInnerText += intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues."+item.type});
                  itemInnerText +=  (item.type==Constants.selectKeys.formulaEditor.optionsToSetDimensionTypes.HISTORIC_PERIODS && item.value) ? " -> " + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.historic_attribute_function"}) + ": " + item.value : "";
                }
                else if(editable || (editableOverrideFormulaString && item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.STRING)) {
                  let optionValue = null;
                  if(item.options_list) {
                    optionValue = item.options_list.find(optionItem => optionItem.value == item.value);
                    optionValue = optionValue ? optionValue.label : null;
                  }
                  itemInnerText += optionValue ? optionValue : item.value;
                }                
                return (
                  <div key={i} className={"free-text-list-list-item" + ((item.value=="" && !item.allow_empty && editable && item.param_type != Constants.formulaEditor.functionParamsTypes.optionsToSetDimension) ? " free-text-list-list-item-required" : "")}>
                    <div title={itemInnerText} className={"free-text-list-list-item-inner"}>
                      {itemInnerText}
                      {(item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula && !item.is_logic_function) ? (
                        <span>
                          <span data-paramindex={i} data-logicalindex={0} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormulaLeft"/></span>
                          {(item.value!=Constants.selectKeys.formulaEditor.logicalComparators.oneterm) && (
                            <React.Fragment>
                              <span className="formula-dimensions-logical-comparator">{item.value}</span>
                              {(item.right_logical_override_string) ? (
                                <span>{item.right_logical_override_string}</span>
                              ) : (
                                <span data-paramindex={i} data-logicalindex={1} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormulaRight"/></span>
                              )}
                            </React.Fragment>
                          )}                          
                        </span>
                      ) : (item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula && !item.is_logic_function) ? (
                        <span>
                          <FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.dimensionLabel"/>
                          {(item.value!=Constants.selectKeys.formulaEditor.logicalComparators.oneterm) && (
                            <React.Fragment>
                              <span className="formula-dimensions-logical-comparator">{item.value}</span>
                              {(item.right_logical_override_string) ? (
                                <span>{item.right_logical_override_string}</span>
                              ) : (
                                <span data-paramindex={i} data-logicalindex={1} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormulaRight"/></span>
                              )}
                            </React.Fragment>
                          )}                          
                        </span>
                      ) : ((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula || item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) && item.is_logic_function) ? (
                        <span data-paramindex={i} data-logicalindex={0} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormula"/></span>
                      ) : ((!editable && !(editableOverrideFormulaString && item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.STRING)) || 
                           (item.param_type==Constants.formulaEditor.functionParamsTypes.optionsToSetDimension && item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.FREE)) ? (
                        <span data-paramindex={i} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormula"/></span>
                      ) : null}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        {((item.param_type == Constants.formulaEditor.functionParamsTypes.logicalFormula || item.param_type == Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) || editable || editableOverrideFormulaString) && (
                          <i 
                            className="fas fa-edit"
                            onClick={this.handleClickEdit}
                            data-index={i}
                            data-value={JSON.stringify(item)}
                          />
                        )}
                        {item.optional && (
                          <i
                            className="fas delete-action fa-trash"                          
                            data-index={i}
                            data-delete={"true"}
                            data-functionparameditor={"true"}
                            data-value={JSON.stringify(item)}
                            data-path={dataPath}
                            onClick={onChange}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              }
            })}
         </div>
      </div>
    );
  }
}

export default FunctionParamsEditor;




// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/objectInputs/functionParamsEditor.jsx